import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import { adminInstance } from '../services/axiosInstance'; // '../axiosInstance';
import { Form, Button, Table, InputGroup, Badge, Accordion, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function ExpenseApprovalListPage() {
    const hierarchy = sessionStorage.getItem('role');
    const [request, setRequest] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [data, setdata] = useState([]);

    useEffect(() => {
        fetchRequest();
    }, []);

    const fetchRequest = async () => {
        try {
            debugger;

            const response = await adminInstance.get(`expenserequest/GetPending/${hierarchy}`);
            setRequest(response.data || []);
            setdata(response.data || []);
        } catch (error) {
            console.error('Error fetching orders:', error.message);
            debugger;
        } finally {
            console.log('Fetch process completed.');
        }
    };

    const navigate = useNavigate();

    const handleView = (reqId) => {
        var urlName = "ExpenseApprovalDetail";
        navigate(`/${urlName}/${reqId}`);
    }

    const handleViewTrip = (tripId) => {
        var urlName = "ExpenseAdminApprovalDetail";
        navigate(`/${urlName}/${tripId}`);
    }

    const handleApproveTrip = async (tripId) => {

        const hasNonApproved = filteredData.some(
            req => req.TRIP_ID === tripId && req.REQ_STATUS === "Open"
        );

        if (hasNonApproved) {
            // There is at least one request not approved
            // Ask user if they want to proceed
            alert("There are open requests. Please reject or cancel it to proceed with approval?");
                return;
        }

        var obj = {
            IS_ADMIN: hierarchy === "Admin" ? true : false,
            REQ_ID: 0,
            STATUS: "Approved",
            COMMENT: "",
            ROLE: hierarchy,
            TRIP_ID: tripId,
            IS_MANAGER_TRIP_APPROVAL : true
        };

        await adminInstance.put(`/expenserequest/UpdateStatus/${hierarchy}`, obj);
        await fetchRequest();
    }

    const filteredData = data
        .filter(spare =>
            spare.EMP_NAME?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            spare.TRAVEL_TYPE?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Get distinct tripName, tripId, and status from filteredData
    const trips = Array.from(
        filteredData.reduce((map, item) => {
            if (item.TRIP_ID && !map.has(item.TRIP_ID)) {
                map.set(item.TRIP_ID, {
                    tripId: item.TRIP_ID,
                    tripName: item.TRIP_NAME,
                    EMP_NAME: item.EMP_NAME, // Assuming EMP_NAME is the employee name
                    status: item.TRIP_STATUS,
                    tripDate: item.REQ_DATE, // optional, if you want to show created date
                    requests: []
                });
            }
            return map;
        }, new Map()).values()
    );

    const getBadgeVariant = (status) => {
        switch (status) {
            case "Open":
                return "warning";
            case "Submitted":
                return "info";
            case "Approved":
            case "Completed":
                return "success";
            case "Cancelled":
            case "Rejected":
                return "danger";
            default:
                return "secondary";
        }
    };

    const getTotalAmount = (requests) =>
        requests.reduce((sum, req) => sum + (req.TOTAL_AMT || 0), 0);

    return (
        <>

            <>
                <div className="card aon-card">
                    <div className="card-header aon-card-header">
                        <h4>
                            Reimbursement Approval List
                        </h4>
                    </div>
                    <div className="card-body aon-card-body">
                        { false &&
                            <div className="sf-bs-data-table">
                                <div className="table-responsive">
                                    {/* Not  */}
                                    <table className="table table-striped table-bordered example-dt-table aon-booking-table responsive" style={{ width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th>Id</th>
                                                <th>Date</th>
                                                <th>Trip</th>
                                                <th>Travel Date</th>
                                                <th>Employee</th>
                                                <th>Travel Type</th>
                                                <th>Amount</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr >
                                                <td colSpan={9}>
                                                    <InputGroup className="mb-3">
                                                        <Form.Control
                                                            placeholder="Search request..."
                                                            value={searchTerm}
                                                            onChange={e => setSearchTerm(e.target.value)}
                                                        />
                                                    </InputGroup>
                                                </td>
                                            </tr>
                                            {
                                                filteredData?.map((emp, index) => {
                                                    return (
                                                        <tr key={uuidv4()}>
                                                            <td>{emp.ID}</td>
                                                            <td>{new Date(emp.REQ_DATE).toLocaleDateString('en-GB', {
                                                                day: '2-digit',
                                                                month: 'short',
                                                                year: 'numeric'
                                                            })}</td>
                                                            <td>{emp.TRIP_NAME}</td>
                                                            <td>{new Date(emp.TRAVEL_DATE).toLocaleDateString('en-GB', {
                                                                day: '2-digit',
                                                                month: 'short',
                                                                year: 'numeric'
                                                            })}</td>
                                                            <td>{emp.EMP_NAME}</td>
                                                            <td>{emp.TRAVEL_TYPE}</td>
                                                            <td>{emp.TOTAL_AMT}</td>
                                                            <td>{emp.REQ_STATUS}</td>
                                                            <td>
                                                                <button className="admin-button wid-200" onClick={() => handleView(emp.ID)} style={{ marginRight: 20 }}>View</button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }

                        <Accordion defaultActiveKey="0">
                            {trips.map((trip, index) => (
                                <Card key={trip.tripId} className="mb-2">
                                    <Accordion.Item eventKey={index.toString()}>
                                        <Accordion.Header>
                                            <div className="w-100 d-flex justify-content-between align-items-center">
                                                <div>
                                                    <div className="fw-bold">
                                                        #{trip.tripId} — {trip.tripName} — {trip.EMP_NAME }
                                                    </div>
                                                    <div className="text-muted small">
                                                        Created: {new Date(trip.tripDate).toLocaleDateString('en-GB')}
                                                    </div>
                                                </div>

                                                <div className="d-flex align-items-center">
                                                    <Badge bg={getBadgeVariant(trip.status)} className="me-3 px-3 py-2">
                                                        {trip.status}
                                                    </Badge>

                                                    {(hierarchy === "Admin" || hierarchy === "Auditor") &&
                                                        <Button variant="outline-primary" style={{ marginRight: 20 }}
                                                            onClick={(e) => { e.stopPropagation(); handleViewTrip(trip.tripId) }} >View</Button>}
                                                    {hierarchy === "Manager" &&
                                                        <Button variant="outline-primary" style={{ marginRight: 20 }}
                                                            onClick={(e) => { e.stopPropagation(); handleApproveTrip(trip.tripId) }}>Approve</Button>}

                                                    <div className="me-3 fw-semibold text-success">
                                                        ₹{getTotalAmount(filteredData?.filter(s => s.TRIP_ID === trip.tripId)).toFixed(2)}
                                                    </div>

                                                </div>
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            {filteredData?.filter(s => s.TRIP_ID === trip.tripId).length > 0 ? (
                                                <Table striped bordered hover responsive size="sm">
                                                    <thead>
                                                        <tr>
                                                            <th>Id</th>
                                                            <th>Date</th>
                                                            <th>Travel Date</th>
                                                            <th>Employee</th>
                                                            <th>Travel Type</th>
                                                            <th>Amount</th>
                                                            <th>Status</th>
                                                            {hierarchy === "Manager" && <th>Action</th>}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {filteredData?.filter(s => s.TRIP_ID === trip.tripId)?.map((emp, idx) => (
                                                            <tr key={uuidv4()}>
                                                                <td>{emp.ID}</td>
                                                                <td>{new Date(emp.REQ_DATE).toLocaleDateString('en-GB', {
                                                                    day: '2-digit',
                                                                    month: 'short',
                                                                    year: 'numeric'
                                                                })}</td>
                                                                <td>{new Date(emp.TRAVEL_DATE).toLocaleDateString('en-GB', {
                                                                    day: '2-digit',
                                                                    month: 'short',
                                                                    year: 'numeric'
                                                                })}</td>
                                                                <td>{emp.EMP_NAME}</td>
                                                                <td>{emp.TRAVEL_TYPE}</td>
                                                                <td>{emp.TOTAL_AMT}</td>
                                                                <td><Badge bg={getBadgeVariant(emp.REQ_STATUS)} className="me-2">
                                                                    {emp.REQ_STATUS}
                                                                </Badge></td>
                                                                {hierarchy === "Manager" && <td>
                                                                    <Button variant="outline-primary" onClick={() => handleView(emp.ID)} style={{ marginRight: 20 }}>View</Button>
                                                                </td>}
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            ) : (
                                                <p className="text-muted">No requests added yet.</p>
                                            )}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Card>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </>

        </>
    );
}

export default ExpenseApprovalListPage;
